import { AuthConfig, AuthHttp } from 'angular2-jwt';
import { ConfirmDialogModule, ConfirmationService, DropdownModule } from 'primeng/primeng';
import { ErrorHandler, NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, RequestOptions } from '@angular/http';

import { AuthGuard } from './services/auth-guard.service';
import { AuthenticationService } from './services/authentication.service';
import { CanDeactivateGuard } from './services/can-deactivate-guard.service';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie';
import { CurrentUserComponent } from './current-user/current-user.component';
import { EntityService } from './services/entity.service';
import { ExceptionHandler } from './exception-handler';
import { GlobalService } from './services/global.service';
import { HomeGuard } from './services/home-guard.service';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { LanguageService } from './services/language.service';
import { NavComponent } from './nav/nav.component';
import { NotifierModule } from './notifier/notifier.module';
import { QueryParamsService } from './services/query-params.service';
import { RoleGuard } from './services/role-guard.service';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UsersService } from './services/users.service';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { SidebarComponent } from 'app/core/sidebar/sidebar.component';
import { InsuredNotificationService } from 'app/shared-model/services/insuredNotificationService';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NotifierModule,
    TranslateModule,
    ConfirmDialogModule,
    DropdownModule
  ],

  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,

    NotifierModule,
    ConfirmDialogModule,
    LanguageSelectorComponent,
    NavComponent,
    SidebarComponent
  ],

  declarations: [
    CurrentUserComponent,
    LanguageSelectorComponent,
    NavComponent,
    SidebarComponent
  ],

  providers: [
    { provide: ErrorHandler, useClass: ExceptionHandler },
    { provide: AuthHttp, useFactory: authHttpServiceFactory, deps: [Http, RequestOptions] },
    AuthenticationService,
    CookieService,
    CanDeactivateGuard,
    AuthGuard,
    RoleGuard,
    HomeGuard,
    EntityService,
    QueryParamsService,
    GlobalService,
    ConfirmationService,
    LanguageService,
    UsersService,
    InsuredNotificationService
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'sf.token',
    tokenGetter: (() => localStorage.getItem('sf.token')),
    noJwtError: true,
  }), http, options);
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/core.module.ts